import './RelatedServicesSkeleton.scss';

const RelatedServicesSkeleton = () => {

  return (
    <div className='related__services__section__skeleton'>
      <div className='related__services__section__title__skeleton'></div>
      <div className='related__services__section__wrapper__skeleton'>
        {[...Array(4)].map((_, i) => (
          <div key={i} className='services__related__links__item__skeleton'>
            <div className="related__icon__skeleton"></div>
            <div className='related__link__item__skeleton'></div>
            <div className='related__link__item__skeleton--primary'></div>
            {[...Array(4)].map((_, i) => (
              <div key={i} className='services__related__link__text__skeleton'></div>
            ))}
            <div className='services__related__link__text__skeleton--primary'></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RelatedServicesSkeleton;